import axios from "../../utils/axios";
import { TemplateVersionViewResponseDTO } from "../types/templateMiscDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const addTemplateVersionViews = (addedTemplateVersionViews) =>
  axios.post<TemplateVersionViewResponseDTO[]>(`${apiUrl}/templateVersionView`, addedTemplateVersionViews.templateVersionIds);

const templateVersionViewService = {
    addTemplateVersionViews
};

export default templateVersionViewService;
